(ns admin.containers.curriculum-learner-reports-index
  (:require [re-frame.core :as re-frame]
            [kyber.lib.kyber-db :as kyber-db]
            [kyber.styles.core :refer [styles->classes gs]]
            [kyber.components.base.link :as link]
            [kyber.components.base.icons :as icons]
            [kyber.components.base.text :as text]
            [admin.constants :as c]
            [admin.router.utils :refer [admin-path]]))

(def classes
  (styles->classes
   {:banner
    {:min-height (gs [:spacing :p64])
     :background (gs [:colors :primary-gray-700])
     :display :flex
     :align-items :center
     :padding [(gs [:spacing :p0])
               (gs [:spacing :p20])]}

    :container
    {:width "100%"
     :max-width (str c/page-max-width "px")
     :margin "0 auto"}

    :curriculum-panel
    {:margin [(gs [:spacing :p20])
              (gs [:spacing :p0])]
     :padding (gs [:spacing :p20])
     :width "100%"
     :background (gs [:colors :true-white])}}))

(defn- activity-panel
  [{:keys [activity curriculum-uuid]}]
  (let [{activity-name :activity/name
         activity-uuid :activity/uuid
         :activity/keys [plo-type]}
        activity

        report-href
        (admin-path :learner-reports-activity
                    :curriculum-uuid curriculum-uuid
                    :activity-uuid activity-uuid)]
    [:div {:style {:display :flex
                   :align-items :center
                   :margin-bottom (gs [:spacing :p12])}}
     [icons/icon-lg (case plo-type
                      "pdf" :file-pdf
                      "video" :file-video
                      (js/console.error "PLO Type not supported"))]
     [link/link {:href report-href
                 :style {:font-size (gs [:font-size :title-20])
                         :flex 1
                         :margin-left (gs [:spacing :p12])}}
      activity-name]
     [link/primary-anchor-button
      {:href report-href}
      "Learner Report"]]))

(defn- curriculum-panel [{:keys [curriculum params]}]
  (let [{:keys [curriculum-uuid]} params
        {:curriculum/keys [activities]} curriculum]
    [:div {:class (:curriculum-panel classes)}
     [text/title-10 :p
      {:style {:color (gs [:colors :primary-gray-600])}}
      "CURRICULUM"]
     [text/title-30 :p (:curriculum/name curriculum)]

     (for [activity activities]
       [activity-panel {:key (:activity/uuid activity)
                        :activity activity
                        :curriculum-uuid curriculum-uuid}])]))

(defn render [{:keys [params]}]
  (let [curriculum
        (re-frame/subscribe
         [::kyber-db/get-record
          {:model :curriculum
           :ident (:curriculum-uuid params)}
          [:curriculum/uuid
           :curriculum/name
           {:curriculum/activities
            [:activity/uuid
             :activity/name]}]])]
    [:<>
     [:div {:class (:banner classes)}
      [:div {:class (:container classes)}
       [text/body-20
        :span
        {:style {:color (gs [:colors :true-white])
                 :font-size (gs [:font-size :body-30])}}
        "Learner Reports"]]]
     [:div {:class (:container classes)
            :style {:margin-top (gs [:spacing :p40])}}
      [curriculum-panel {:curriculum @curriculum
                         :params params}]]]))
